import {atom} from "recoil";
import {generateHash} from "../../utils/ApplicationUtils";

export const stateApplicationHash = atom<string | null>({
    key: 'dataHash',
    default: !!window.__CONSTRUCTOR_STATE__ ? generateHash() : null,
});
